import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import ContractDetails from '../../components/ContractDetails/ContractDetails'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const ContractDetailsPage = () => {
    return (
        <>
            <Helmet>
                <title>Contract Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <ContractDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ContractDetailsPage